import { BaseController } from '../../../common/base/controller';
import _ from 'lodash';

export class ProgressController extends BaseController {
  constructor(controllerService, progressService, typesToIconsMapping, ticketFlowService) {
    'ngInject';
    super({ controllerService, progressService, typesToIconsMapping, ticketFlowService });
  }

  get nextState() {
    return this.progressService.getNextState(this.routes);
  }

  get previousState() {
    return this.progressService.getPreviousState(this.routes);
  }

  get canGoToPreviousDetailView() {
    return this.previousState && this.progressService.mayNavigateTo(this.previousState, this.routes, this.activeRoutes);
  }

  get canGoToNextDetailView() {
    return this.nextState && this.progressService.mayNavigateTo(this.nextState, this.routes, this.activeRoutes);
  }

  get visibleStates() {
    return _.filter(this.routes, r => !r.hidden);
  }

  get steps() {
    return this.progressService.getStates(this.visibleStates);
  }

  get progressBarClasses() {
    const firstDeadline = _.filter(this.visibleStates, vs => vs.deadline.type === 'first').length;
    const secondDeadline = _.filter(this.visibleStates, vs => vs.deadline.type === 'second').length;
    const thirdDeadline = _.filter(this.visibleStates, vs => vs.deadline.type === 'third').length;
    return `fg-progress-bar-${firstDeadline}-${secondDeadline}-${thirdDeadline}`;
  }

  getDeadlineForStep(step) {
    return this.progressService.isDeadlineActive(step, this.routes, this.activeRoutes, this.ticket) ? this.deadline : null;
  }

  $onInit() {
  }

  isActiveStep(step) {
    const type = this.getTypeForState(step);
    return type.indexOf('active') > -1;
  }

  getTypeForState(step) {
    return this.progressService.getTypeForState(step, this.routes, this.activeRoutes, this.ticket);
  }

  getClasses(step, index) {
    const type = this.getTypeForState(step);
    const deadline = this.progressService.getDeadlineForState(step, this.routes);
    let classes = _.kebabCase(type);
    if (this.progressService.getIsCurrent(step)) {
      classes += ' active';
    }
    if (!this.progressService.mayNavigateTo(step, this.routes, this.activeRoutes, this.ticket)) {
      classes += ' disabled';
    }
    if (index === 0) {
      classes += ' first';
    }
    if (deadline) {
      classes += ` deadline-${deadline.type}`;
    }
    return classes;
  }

  getDeadlineClasses(step) {
    const type = this.progressService.getTypeForDeadline(step, this.routes, this.activeRoutes, this.ticket);
    return _.kebabCase(type);
  }

  getTranslation(step) {
    const type = this.progressService.getTypeForDeadline(step, this.routes, this.activeRoutes, this.ticket);
    return `app.progress.${_.camelCase(type)}`;
  }

  getIcons(step) {
    const type = this.progressService.getTypeForState(step, this.routes, this.activeRoutes, this.ticket);
    if (this.typesToIconsMapping[type]) {
      return 'fa ' + this.typesToIconsMapping[type];
    }
    return 'empty';
  }

  navigateTo(state) {
    if (this.progressService.mayNavigateTo(state, this.routes, this.activeRoutes, this.ticket)) {
      this.navigate({state});
    }
  }

  previousDetailView() {
    if (this.canGoToPreviousDetailView) {
      this.navigate({state:this.previousState});
    }
  }

  nextDetailView() {
    if (this.canGoToNextDetailView) {
      this.navigate({state:this.nextState});
    }
  }
}
